const getCloudName = () => process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;

const stripExtension = (publicId) => String(publicId || '').replace(/\.(mp4|mov|webm|m3u8)$/i, '');

const buildVideoUrl = (publicId, transform, extension = 'mp4') => {
  const cloudName = getCloudName();
  const normalizedPublicId = stripExtension(publicId);
  if (!cloudName || !normalizedPublicId) return null;

  return `https://res.cloudinary.com/${cloudName}/video/upload/${transform}/${normalizedPublicId}.${extension}`;
};

export const getIntroVideoPosterUrl = (publicId) =>
  buildVideoUrl(publicId, 'c_fill,w_640,h_854,so_1,f_jpg,q_auto', 'jpg');

export const getIntroVideoHoverPreviewUrl = (publicId) =>
  buildVideoUrl(publicId, 'c_fill,w_640,h_854,du_30,vc_auto,q_auto,f_mp4', 'mp4');

export const getIntroVideoFullUrl = (publicId) =>
  buildVideoUrl(publicId, 'q_auto,f_auto', 'mp4');

export const getIntroVideoHlsUrl = (publicId) =>
  buildVideoUrl(publicId, 'sp_full_hd', 'm3u8');

export const normalizeIntroVideo = (video) => {
  if (!video) return null;
  if (video.url === null) return null;

  const publicId = video.publicId || video.public_id || video.intro_video_public_id || '';
  return {
    url: video.url || video.secure_url || video.intro_video_url || getIntroVideoFullUrl(publicId),
    hlsUrl: video.hlsUrl || video.hls_url || video.intro_video_hls_url || getIntroVideoHlsUrl(publicId),
    posterUrl:
      video.posterUrl ||
      video.poster_url ||
      video.intro_video_poster_url ||
      getIntroVideoPosterUrl(publicId),
    publicId,
    duration: video.duration || video.durationSec || video.intro_video_duration_sec || null,
  };
};
